/* global axios */
import ApiClient from './ApiClient';

class ScheduledMessageAPI extends ApiClient {
  constructor() {
    super('scheduled_messages', { accountScoped: true });
  }

  getForConversation(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }
}

export default new ScheduledMessageAPI();
